import React from "react";
import styled from "styled-components/macro";
import myTuluCover from "../../../images/rrspPDF.png";
const RideRentPrintShop = () => {
  const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: row;
    padding: 1080px;
    font-family: "Lexend", serif;
    height: 900px;
    width: 1920px;
    padding: 0px;
    align-items: center;
  `;

  const SectionWrapper = styled.div`
    margin-left: 100px;
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0 30px 0 0;
    height: 638px;
    margin-left: 60px;
    width: "323px";
    margin-top: 55px;
  `;

  const Section = styled.div`
    display: flex;
    position: relative;
    width: 330px;
    height: 50%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 40px 0;
    border-top: solid 2px #010101;
  `;

  return (
    <Wrapper>
      <img
        src={myTuluCover}
        alt={"myTuluCover"}
        style={{
          objectFit: "cover",
          height: 643,
          width: 910,
          marginLeft: 97,
          marginTop: 55,
        }}
      />

      <SectionWrapper>
        <Section>
          <Title>Rent</Title>
          <Text>
            {
              "Provide your residents with everything from vacuum cleaners to home theater projectors"
            }
          </Text>
        </Section>

        <Section>
          <Title>Shop</Title>
          <Text>
            {
              "Offer a range of products that residents can purchase on the spot"
            }
          </Text>
        </Section>
      </SectionWrapper>

      <SectionWrapper>
        <Section>
          <Title>Ride</Title>
          <Text>
            {"Your own in-building micro-mobility solution for residents"}
          </Text>
        </Section>

        <Section>
          <Title>Print</Title>
          <Text>
            {
              "Residents can now do all their business without needing an office"
            }
          </Text>
        </Section>
      </SectionWrapper>
    </Wrapper>
  );
};

export { RideRentPrintShop };

const Title = styled.div`
  z-index: 1;
  font-size: 50px;
  font-weight: bold;
  white-space: pre;
  text-transform: uppercase;
`;

const Text = styled.p`
  z-index: 1;
  font-size: 25px;
  margin-bottom: 0;
  display: flex;
  white-space: pre-wrap;
  font-family: "DMSans", serif;
`;
